export var DEFAULT_CLASS_NAME = 'accordions-popup-menu-link';
export var DEFAULT_DESKTOP_PROPS = {
  fullScreen: true
};